import { render, staticRenderFns } from "./MasterDetail.vue?vue&type=template&id=6da48c9f&"
import script from "./MasterDetail.vue?vue&type=script&lang=js&"
export * from "./MasterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports